import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

// Types for modal data
import type { Equipment } from "../../features/CourseBuilder/components/EquipmentsTab/types/types";
import type { Lab } from "../../features/CourseBuilder/components/LabsTab/types";

export interface ModalState {
	customizeChallan: {
		isOpen: boolean;
	};
	instituteDetailsModal: {
		isOpen: boolean;
	};
	addEquipmentModal: {
		isOpen: boolean;
	};
	editEquipmentModal: {
		isOpen: boolean;
		equipment?: Equipment;
	};
	addLabModal: {
		isOpen: boolean;
	};
	editLabModal: {
		isOpen: boolean;
		lab?: Lab;
	};
	addMemberModal: {
		isOpen: boolean;
	};
	committeeDetailsModal: {
		isOpen: boolean;
	};
	sessionStatusModal: {
		isOpen: boolean;
	};
	profileModal: {
		isOpen: boolean;
	};
	signatureRequiredModal: {
		isOpen: boolean;
	};
}

const initialState: ModalState = {
	customizeChallan: {
		isOpen: false,
	},
	instituteDetailsModal: {
		isOpen: false,
	},
	addEquipmentModal: {
		isOpen: false,
	},
	editEquipmentModal: {
		isOpen: false,
		equipment: undefined,
	},
	addLabModal: {
		isOpen: false,
	},
	editLabModal: {
		isOpen: false,
		lab: undefined,
	},
	addMemberModal: {
		isOpen: false,
	},
	committeeDetailsModal: {
		isOpen: false,
	},
	sessionStatusModal: {
		isOpen: false,
	},
	profileModal: {
		isOpen: false,
	},
	signatureRequiredModal: {
		isOpen: false,
	},
};

const modalSlice = createSlice({
	name: "modal",
	initialState,
	reducers: {
		openModal: (state, action: PayloadAction<keyof ModalState>) => {
			state[action.payload].isOpen = true;
		},
		closeModal: (state, action: PayloadAction<keyof ModalState>) => {
			state[action.payload].isOpen = false;
		},
		// For modals that need additional data
		openModalWithData: (state, action: PayloadAction<{ modalKey: keyof ModalState; data?: unknown }>) => {
			state[action.payload.modalKey].isOpen = true;
			// Add data handling if needed
		},
		openEditEquipmentModal: (state, action: PayloadAction<Equipment>) => {
			state.editEquipmentModal.isOpen = true;
			state.editEquipmentModal.equipment = action.payload;
		},
		closeEditEquipmentModal: state => {
			state.editEquipmentModal.isOpen = false;
			state.editEquipmentModal.equipment = undefined;
		},
		openEditLabModal: (state, action: PayloadAction<Lab>) => {
			state.editLabModal.isOpen = true;
			state.editLabModal.lab = action.payload;
		},
		closeEditLabModal: state => {
			state.editLabModal.isOpen = false;
			state.editLabModal.lab = undefined;
		},
	},
});

export const {
	openModal,
	closeModal,
	openModalWithData,
	openEditEquipmentModal,
	closeEditEquipmentModal,
	openEditLabModal,
	closeEditLabModal,
} = modalSlice.actions;
export default modalSlice.reducer;
